import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles/index'
import {Button} from '../../../components'
import {Container, Title, Subtitle} from '../../flow'
import {LoadingIndicator} from '../../../components'
import TextField from 'material-ui/TextField'
import Dialog, {DialogTitle, DialogContent, DialogContentText, DialogActions} from 'material-ui/Dialog'
import Typography from 'material-ui/Typography'
import Grid from '../../../common/components/Grid'
import {FormControl, FormHelperText} from 'material-ui/Form'
import Input, {InputLabel} from 'material-ui/Input'
import {changePhone as text} from '../../profile/text'
import MaskedInput from 'react-text-mask'

const styles = (theme) => ({
  container: {maxWidth: 328, margin: '0 auto'},
  title: {marginBottom: 20},
  button: {margin: '5px 0'},
  error: {color: 'red', margin: '1rem 0 0 0', textAlign: 'center'},
  sendError: {color: 'red', textAlign: 'center', marginBottom: '1rem'}
})

class PhoneStep extends React.Component {

  static displayName = 'PhoneStep.component'

  static propTypes = {
    requestNextStep: PropTypes.func.isRequired,
    setCountryCode: PropTypes.func.isRequired,
    countryCode: PropTypes.string,
    setNumber: PropTypes.func.isRequired,
    number: PropTypes.string,
    setCode: PropTypes.func.isRequired,
    code: PropTypes.string,
    sendCode: PropTypes.func.isRequired,
    setOpenDialog: PropTypes.func,
    open: PropTypes.bool,
    save: PropTypes.func,
    isSending: PropTypes.bool,
    isSaving: PropTypes.bool,
    sendError: PropTypes.string,
    saveError: PropTypes.string,
    updateUrl: PropTypes.func.isRequired,
  }

  componentDidMount() {
    this.props.updateUrl()
  }

  render() {
    const {classes} = this.props
    return (
      <Container className={classes.container}>
        <Title className={classes.title}>Para comenzar, debemos verificar tu número de teléfono</Title>
        <Subtitle>Recibirás un SMS. Tu compañía telefónica puede aplicar algunos cargos</Subtitle>
        <div style={{display: 'flex', margin: '15px 0 25px 0'}}>
          <FormControl style={{width: 120, paddingRight: 10, textAlign: 'center'}}>
            <InputLabel htmlFor="phone">Código País</InputLabel>
            <Input
              id="phone"
              startAdornment={<span style={{position: 'relative', top: 6}}>+&nbsp;</span>}
              type="tel"
              value={this.props.countryCode}
              onChange={e => this.props.setCountryCode(e.target.value)}
            />
          </FormControl>
          <FormControl fullWidth>
            <InputLabel htmlFor="phone" shrink>Número</InputLabel>
            <Input
              style={{flex: 1, textAlign: 'center'}}
              type="tel"
              label={'Número'}
              placeholder={''}
              autoFocus={true}
              value={this.props.number}
              onChange={e => this.props.setNumber(e.target.value)}
              inputComponent={TextMaskCustom}
            />
            <FormHelperText><span>Incluye el código de área. <br/>Ej: 11 para Bs. As.</span></FormHelperText>
          </FormControl>
        </div>
        <div>
          {this.props.sendError !== '' ? (
            <Grid item xs={12}>
              <Typography className={classes.sendError} gutterBottom={true}>{this.props.sendError}</Typography>
            </Grid>
          ) : null}
        </div>
        <LoadingIndicator show={this.props.isSending}>
          <Button
            variant={'primary'}
            fullWidth={true}
            className={classes.button}
            onClick={() => this.props.sendCode()}
          >
            Verificar
          </Button>
        </LoadingIndicator>
        <Dialog
          open={this.props.open}
          onClose={() => this.props.setOpenDialog(false)}
        >
          <form>
            <DialogTitle>Ingresa el código enviado por SMS</DialogTitle>
            <DialogContent>
              <DialogContentText>El código tiene una validez de 2 horas desde generado.</DialogContentText>
              <Grid container>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <InputLabel htmlFor="phone">{text.dialog.labelPhoneNumber}</InputLabel>
                    <Input
                      id="phone"
                      type="tel"
                      autoFocus={true}
                      value={'+' + this.props.countryCode + ' ' + this.props.number}
                      disabled={true}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label={text.dialog.labelCode}
                    fullWidth
                    value={this.props.code}
                    onChange={e => this.props.setCode(e.target.value)}
                  />
                </Grid>
              </Grid>
              {this.props.saveError !== '' ? (
                <Grid item xs={12}>
                  <Typography className={classes.error}>{this.props.saveError}</Typography>
                </Grid>
              ) : null}
            </DialogContent>
            <DialogActions>
              <Button
                variant={'secondary'}
                onClick={() => this.props.setOpenDialog(false)}
              >
                {text.dialog.cancel}
              </Button>
              <LoadingIndicator show={this.props.isSaving}>
                <Button
                  variant={'primary'}
                  style={{height: 46}}
                  onClick={this.props.save}
                >
                  {text.dialog.accept}
                </Button>
              </LoadingIndicator>
            </DialogActions>
          </form>
        </Dialog>
      </Container>
    )
  }
}

export default withStyles(styles, {withTheme: true})(PhoneStep)

const TextMaskCustom = ({inputRef, ...other}) => (
  <MaskedInput
    {...other}
    ref={inputRef}
    mask={['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
    placeholderChar={'\u2000'}
    showMask={true}
  />
)



// WEBPACK FOOTER //
// ./src/sections/depositV2/components/phone.step.jsx